import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { getExtension } from '../../extension-details/state/extension-detail.selectors';
import { PhoneDetailSaveModel } from '../models/phone-detail-save.model';
import { AddPhoneApiService } from '../services/add-phone-api.service';
import * as AddPhoneActions from './add-phone.actions';

@Injectable()
export class AddPhoneEffects {
   savePhone$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddPhoneActions.savePhone),
         withLatestFrom(this.store.select(getExtension)),
         switchMap(([action, extension]) => {
            const phone: PhoneDetailSaveModel = {
               ...action.phoneSave,
               sipUsers:
                  action.phoneSave.sipUsers?.map((sipUser) => {
                     return { ...sipUser, accountId: extension?.accountId };
                  }) ?? null,
            };
            return this.addPhoneApiService.save(phone).pipe(
               map((executionResult) => {
                  return AddPhoneActions.savePhoneSuccess({
                     phoneType: executionResult.data.phone.phoneType,
                  });
               }),
               catchError((error) => {
                  return of(AddPhoneActions.savePhoneFailure(error));
               })
            );
         })
      );
   });

   savePhoneSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddPhoneActions.savePhoneSuccess),
            tap((result) => {
               this.dialogService.closeFormComponent();
               this.snackbar.open(`${result.phoneType} phone Saved`, undefined, {
                  duration: 3000,
               });
            })
         );
      },
      { dispatch: false }
   );

   addPhoneToRegister$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddPhoneActions.addPhoneToRegister),
            tap((result) => {
               this.dialogService.closeFormComponent();
            })
         );
      },
      { dispatch: false }
   );

   constructor(
      private actions$: Actions,
      private addPhoneApiService: AddPhoneApiService,
      private store: Store,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService
   ) {}
}
